import { render, staticRenderFns } from "./HistoryDisplay.vue?vue&type=template&id=649fe628&"
import script from "./HistoryDisplay.vue?vue&type=script&lang=js&"
export * from "./HistoryDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports